// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2sM0S","colMaxWidth":"Table_colMaxWidth__2EuL_"};